var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMcatChatLogoMobile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#233851",
    d: "M3.32 18.615c6.235-0.956 9.803-4.348 10.777-10.34 0.568 2.617 1.407 5.054 3.405 6.979 2.029 1.955 4.558 2.855 7.438 3.333-6.239 0.958-9.862 4.328-10.809 10.405-1.003-5.975-4.508-9.458-10.812-10.375l.002-.002ZM13.846 7.329c-3.833 0.729-6.106 2.836-6.809 6.64C6.222 10.259 4.055 7.952 0 7.429 3.517 5.994 5.878 3.668 7.082 0.452c0.623 3.978 2.919 6.152 6.764 6.877Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#233851",
    d: "M21.388 4.81c0.69 2.986 2.203 4.713 4.997 5.248-2.738 0.658-4.325 2.275-4.97 5.298C20.755 12.327 19.157 10.7 16 10.098c3.111-0.648 4.775-2.212 5.388-5.291v.004Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMcatChatLogoMobile);
export default __webpack_public_path__ + "static/media/MCAT-chat-logo-mobile.d0d47b2c73afeb1f2276e5437677e4aa.svg";
export { ForwardRef as ReactComponent };